module.exports = __webpack_public_path__ + "static/img/zhucechenggong.ce11864.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/DiscountAgentInvite/PC/zhucechenggong.png
// module id = 7Oc2
// module chunks = 69